import React from 'react';
import { SvgIcon } from '../SvgIcon';

export default React.memo(
	React.forwardRef((props: any, ref: any) => {
		return (
			<SvgIcon data-testid={`${'Close'}Icon`} ref={ref} {...props}>
				<path style={{ color: 'inherit' }} transform="scale(1,1)" d="M810 750l-238-238 238-238-60-60-238 238-238-238-60 60 238 238-238 238 60 60 238-238 238 238z" />
			</SvgIcon>
		);
	}),
);

export const Close = React.memo(
	React.forwardRef((props: any, ref: any) => {
		return (
			<SvgIcon data-testid={`${'Close'}Icon`} ref={ref} {...props}>
				<path style={{ color: 'inherit' }} transform="scale(1,1)" d="M810 750l-238-238 238-238-60-60-238 238-238-238-60 60 238 238-238 238 60 60 238-238 238 238z" />
			</SvgIcon>
		);
	}),
);
